import { render, staticRenderFns } from "./knowPoint.vue?vue&type=template&id=577997be&scoped=true"
import script from "./knowPoint.vue?vue&type=script&lang=js"
export * from "./knowPoint.vue?vue&type=script&lang=js"
import style0 from "./knowPoint.vue?vue&type=style&index=0&id=577997be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577997be",
  null
  
)

export default component.exports